import React from "react";
import { Modal, Row, Col } from "antd";
import moment from "moment";
import { EqIconCalendar, EqIconPrice } from "../../custom/eqIcon/EqIcons";
import EqButton from "../../custom/eqButton/EqButton";
import EtTag from "../../../eqComponents/eqCustom/EtTag/EtTag";
import { useTranslation } from "react-i18next";
import { IUnpaidOrdersDto, UnpaidOrdersType } from "../../shared/general/IUnpaidOrders";
import { ticksToMilliSeconds } from "../../shared/Common";
import "./UnpaidOrdersModalSchool.scss";
import { useNavigate } from "react-router-dom";

interface UnpaidOrdersModalSchoolProps {
    isModalVisible: boolean;
    handleCancel: () => void;
    unpaidOrders?: IUnpaidOrdersDto[];
    handleShowMessageModal: (email: string) => void;
    showReminderModal: (email: string) => void;
}

const UnpaidOrdersModalSchool: React.FC<UnpaidOrdersModalSchoolProps> = ({
    isModalVisible,
    handleCancel,
    unpaidOrders,
    handleShowMessageModal,
    showReminderModal,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleRedirect = (item: IUnpaidOrdersDto, orderId: string) => {
        
        if (item.orderType === UnpaidOrdersType.Training) {
            let dataToday = new Date().getTime();
            if (ticksToMilliSeconds(item.date) > dataToday) {
                navigate(`/school/activityBoard?tab=1&&id=${item.itemId}`);
            } else {
                navigate(`/school/activityBoard?tab=5&&id=${item.itemId}`);
            }
        } else if (
            item.orderType === UnpaidOrdersType.Course ||
            item.orderType === UnpaidOrdersType.CourseLesson
        ) {
            navigate(`/school/trainingCourse?id=${item.itemId}`);
        }
    };

    return (
        <Modal
            width={1000}
            title={t("unPaidOrders")}
            className="unpaid-Orders-modal-school"
            open={isModalVisible}
            onCancel={handleCancel}
            footer={null}
            maskClosable={true}
        >
            {unpaidOrders?.map((item, index) => (
                <div className="eq-activity-row" key={index}>
                    <Row className="eq-status-row-border">
                        <Col className="content-col">
                            <Row>
                                <Col>
                                    <div className="date-icon">
                                        <EqIconCalendar
                                            eqWidth={34}
                                            eqHeight={34}
                                            eqClass="eq-cal-icon"
                                            eqFill="#083b49"
                                        />
                                        <div className="day">
                                            {moment(ticksToMilliSeconds(item.date)).format("DD")}
                                        </div>
                                        <div className="month">
                                            {moment(ticksToMilliSeconds(item.date)).format("MMM")}
                                        </div>
                                    </div>
                                </Col>
                                <Col className="header-details">
                                    <Row>
                                        <Col>
                                            <span className="time">{item.userName}</span>
                                        </Col>
                                        <Col>
                                            <EtTag>{UnpaidOrdersType[item.orderType]}</EtTag>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col
                                            onClick={handleRedirect.bind(this, item, item.orderId)}
                                            className="eq-f-th"
                                        >
                                            {item.title}
                                        </Col>
                                        <Col className="price" style={{ paddingLeft: "4px" }}>
                                            <EqIconPrice
                                                eqWidth="15"
                                                eqHeight="13"
                                                eqFill="#b5b5b5"
                                            />{" "}
                                            {item.amount}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col className="action-col">
                            <EqButton
                                style={{ marginRight: "10px" }}
                                onClick={() => handleShowMessageModal(item.userEmail)}
                            >
                                {t("SendAMessage")}
                            </EqButton>
                            <EqButton onClick={() => showReminderModal(item.userEmail)}>
                                {t("sendReminder")}
                            </EqButton>
                        </Col>
                    </Row>
                </div>
            ))}
        </Modal>
    );
};

export default UnpaidOrdersModalSchool;
